// Elasticsearch / OpenSearch returns highlight keys under multiple analyzer
// variants — the base field name plus `.prefixed` and/or `.stemmed` suffixes
// (e.g. `taskAnswers`, `taskAnswers.prefixed`, `taskAnswers.stemmed`). Only one
// variant usually carries hits for a given query. Collapse them back to a single
// logical field, keeping the highest-precedence variant's snippets so a later
// iteration order can't let `.stemmed` beat `.prefixed`: base > .prefixed > .stemmed.
const ANALYZER_VARIANT_PRIORITY: { [source: string]: number } = {
	base: 3,
	prefixed: 2,
	stemmed: 1,
};

export function collapseHighlightAnalyzerVariants(highlight: { [key: string]: string[] }): {
	[key: string]: string[];
} {
	if (!highlight) {
		return {};
	}
	const collapsed: { [key: string]: string[] } = {};
	const sourceByBaseKey: { [baseKey: string]: string } = {};
	Object.keys(highlight).forEach((key) => {
		const value = highlight[key];
		if (!value) {
			return;
		}
		const baseKey = key.replace(/(\.stemmed|\.prefixed)$/, '');
		const source = key === baseKey ? 'base' : key.endsWith('.prefixed') ? 'prefixed' : 'stemmed';
		const existingSource = sourceByBaseKey[baseKey];
		if (
			!existingSource ||
			ANALYZER_VARIANT_PRIORITY[source] > ANALYZER_VARIANT_PRIORITY[existingSource]
		) {
			collapsed[baseKey] = value;
			sourceByBaseKey[baseKey] = source;
		}
	});
	return collapsed;
}

export function restoreCasingInHighlight(highlightStr: string, sourceValue: string): string {
	const plainLower = highlightStr.replace(/<\/?em>/g, '').toLowerCase();
	if (plainLower !== sourceValue.toLowerCase()) {
		return highlightStr;
	}

	let result = '';
	let sourceIdx = 0;
	let charIdx = 0;

	while (charIdx < highlightStr.length) {
		if (highlightStr.startsWith('<em>', charIdx)) {
			result += '<em>';
			charIdx += 4;
		} else if (highlightStr.startsWith('</em>', charIdx)) {
			result += '</em>';
			charIdx += 5;
		} else {
			result += sourceValue[sourceIdx];
			sourceIdx++;
			charIdx++;
		}
	}

	return result;
}
